<template>
  <div v-if="currentMall" class="view-container mb-10 mt-10">
    <ValidationObserver v-slot="{ invalid, handleSubmit }" tag="div" class="height-100">
      <form @submit.prevent="handleSubmit(onSubmit)" class="height-100">
        <p class="font--m-1 mt-5 mb-5 text-center">{{ currentMall.name }} 계정 2차 인증</p>

        <!-- 플랫폼 별 2차 인증 방식에 따라 변동  -->
        <component
          v-if="authComponent"
          :is="authComponent"
          @update:otp="twoAuthForm.otp = $event"
        />

        <BasicButton
          v-if="!isUpdate"
          id="btn__XQp0Ct2cYEOA9BZCRliHfg=="
          class="mt-5"
          color="black"
          :disabled="loading || invalid"
          :loading="loading"
          @click="onSubmit"
        >
          연동하기
        </BasicButton>
        <BasicButton
          v-else
          id="btn__TeO93jPW60aBWvyQotR+6g=="
          class="mt-5"
          color="black"
          :disabled="loading || invalid"
          :loading="loading"
          @click="onSubmit"
        >
          수정하기
        </BasicButton>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: {
    signinForm: {
      type: Object,
    },
    provider: {
      type: String,
    },
    mallUuid: {
      type: String,
    },
  },

  data() {
    return {
      ready: false,
      loading: false,
      twoAuthForm: {
        otp: '',
      },
    }
  },

  computed: {
    ...mapState('mall', ['providers']),
    ...mapGetters('mall', ['providersObj']),

    currentMall() {
      return this.providersObj?.[this.provider]
    },

    /**
     * mallUuid 있으면 계정 정보 수정, 없으면 신규 등록
     */
    isUpdate() {
      return !!this.mallUuid
    },

    /**
     * 현재는 totp만 지원
     */
    authComponent() {
      return () => import('@/pages/signup/mall/two-factor-auth/Totp.vue')
    },

    submitForm() {
      return {
        ...this.signinForm,
        ...this.twoAuthForm,
      }
    },
  },

  async created() {
    // 로그인 정보가 없거나 연동할 플랫폼 정보가 없으면 뒤로
    if (!this.signinForm || (!this.provider && !this.mallUuid)) {
      if (this.provider && !this.mallUuid) {
        // 등록 페이지로
        return await this.$router.push({
          name: 'my/malls/register',
          query: { provider: this.provider },
        })
      } else if (this.mallUuid) {
        // 수정 페이지로
        return await this.$router.push({
          name: 'my/malls/detail',
          params: { uuid: this.mallUuid },
        })
      }

      return await this.$router.push({ name: 'my/malls' })
    } else if (!this.providers) {
      await this.getMallProviders()
    }
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('mall', ['addMalls', 'getMalls', 'getMallProviders', 'updateMalls']),
    ...mapActions('contract', ['getContracts']),

    async onSubmit() {
      if (this.loading) {
        return
      }

      try {
        this.loading = true

        if (this.isUpdate) {
          await this.updateMalls(this.submitForm)
        } else {
          await this.addMalls(this.submitForm)
        }

        await Promise.all([this.getContracts(), this.getMalls(), this.getMe()])

        const confirm = await this.$swal.basic.confirm({
          confirmButtonText: '추가연동하기',
          cancelButtonText: '메인으로',
          html: `${this.currentMall?.name}의 계정 
          ${this.isUpdate ? '수정' : '연동'}이 <br /> 완료되었습니다.`,
        })

        if (confirm.isConfirmed === true) {
          await this.$router.push({ name: 'my/malls' })
        } else {
          await this.$router.push({ name: 'main' })
        }
      } finally {
        this.loading = false
      }
    },
    test(event) {
      console.log('test', event)
      this.$emit('update:otp', event)
      this.twoAuthForm.otp = event
    },
  },
}
</script>

<style lang="scss" scoped></style>
